import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { isAudioNodeOutputConnection } from '../guards/audio-node-output-connection';
export var createIncrementCycleCounterFactory = function createIncrementCycleCounterFactory(cycleCounters, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode) {
  return function (isOffline) {
    return function (audioNode, count) {
      var cycleCounter = cycleCounters.get(audioNode);
      if (cycleCounter === undefined) {
        if (!isOffline && isActiveAudioNode(audioNode)) {
          var nativeSourceAudioNode = getNativeAudioNode(audioNode);
          var _getAudioNodeConnecti = getAudioNodeConnections(audioNode),
            outputs = _getAudioNodeConnecti.outputs;
          var _iterator = _createForOfIteratorHelper(outputs),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var output = _step.value;
              if (isAudioNodeOutputConnection(output)) {
                var nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
              } else {
                var nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                nativeSourceAudioNode.disconnect(nativeDestinationAudioParam, output[1]);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        cycleCounters.set(audioNode, count);
      } else {
        cycleCounters.set(audioNode, cycleCounter + count);
      }
    };
  };
};